<template>
  <div class="rules-container">
    <div class="header">
      <input type="text" placeholder="规则名称" v-model="searchRuleName" />
      <select v-model="searchType">
        <option value="">类型</option>
        <option value="早餐">早餐</option>
        <option value="午餐">午餐</option>
        <option value="晚餐">晚餐</option>
      </select>
      <button class="search-button" @click="search">搜索</button>
      <button class="clear-button" @click="clear">清空</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>规则名称</th>
          <th>类型</th>
          <th>预定规则</th>
          <th>供应规则</th>
          <th>取消规则</th>
          <th>没就餐规则</th>
          <th>修改时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rule in filteredRules" :key="rule.id">
          <td>{{ rule.id }}</td>
          <td>{{ rule.name }}</td>
          <td :class="`type-${rule.type}`">{{ rule.type }}</td>
          <td>{{ rule.yudingRule }}</td>
          <td>{{ rule.gongyingRule }}</td>
          <td>{{ rule.quxiaoRule }}</td>
          <td>{{ rule.meijiucanRule }}</td>
          <td>{{ rule.time }}</td>
          <td>
            <button class="delete-button" @click="deleteRule(rule.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="add-button">
      <button @click="showDrawer = true">添加</button>
    </div>
    <div class="drawer" v-if="showDrawer">
      <div class="drawer-header">
        <h3>添加规则</h3>
        <button @click="showDrawer = false">关闭</button>
      </div>
      <div class="drawer-body">
        <form @submit.prevent="addRule">
          <div class="form-group">
            <label for="ruleName">规则名称</label>
            <input type="text" id="ruleName" v-model="newRule.name" required />
          </div>
          <div class="form-group">
            <label for="ruleType">类型</label>
            <select id="ruleType" v-model="newRule.type">
              <option value="早餐">早餐</option>
              <option value="午餐">午餐</option>
              <option value="晚餐">晚餐</option>
            </select>
          </div>
          <div class="form-group">
            <label for="bookingRule">预定规则</label>
            <div>
              <label>用餐预定价格：</label>
              <input type="number" v-model="newRule.bookingPrice"  step="0.01" required />
            </div>
            <div>
              <label>前一天</label>
              <input type="time" v-model="newRule.bookingTime" required />
              <label>前可预定</label>
            </div>
            <div>
              <label>预定就餐优惠价格：</label>
              <input type="number" v-model="newRule.discountPrice"  step="0.01" required />
            </div>
          </div>
          <div class="form-group">
            <label for="supplyRule">供应规则</label>
            <textarea id="supplyRule" v-model="newRule.supplyRule" required></textarea>
          </div>
          <div class="form-group">
            <label for="cancellationRule">取消规则</label>
            <div>
              <label>前一天：</label>
              <input type="time" v-model="newRule.cancellationTime" required />
              <label>前可取消</label>
            </div>
          </div>
          <div class="form-group">
            <label for="meijiucanRule">没就餐规则</label>
            <div>
              <label>当预定后没去就餐的，扣</label>
              <input type="number" v-model="newRule.meijiucanRule"  step="0.01" required />
              <label>元</label>
            </div>
          </div>
          <button type="submit">保存</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showDrawer: false,
      newRule: {
        name: '',
        type: '',
        bookingPrice: '',
        bookingTime: '',
        discountPrice: '',
        supplyRule: '',
        cancellationTime: '', // 新增字段
        meijiucanRule: ''
      },
      rules: [],
      searchRuleName: '',
      searchType: ''
    };
  },
  computed: {
    filteredRules() {
      return this.rules.filter(rule => {
        const matchesName = this.searchRuleName ? rule.name.includes(this.searchRuleName) : true;
        const matchesType = this.searchType ? rule.type === this.searchType : true;
        return matchesName && matchesType;
      });
    }
  },
  methods: {
    async fetchRules() {
      try {
        const response = await this.$axios.get('/api/show_guize');
        const data = response.data;
        if (data.code === 0) {
          this.rules = data.data;
        } else {
          console.error('Failed to fetch rules:', data.message);
        }
      } catch (error) {
        console.error('Error fetching rules:', error);
      }
    },
    addRule() {
      const ruleData = {
        name: this.newRule.name,
        type: this.newRule.type,
        yudingRule: `用餐预定价格：${this.newRule.bookingPrice}\n前一天${this.newRule.bookingTime}前可预定\n预定就餐优惠价格：${this.newRule.discountPrice}`,
        gongyingRule: this.newRule.supplyRule,
        quxiaoRule: `前一天${this.newRule.cancellationTime}前可取消`, // 新增字段
        meijiucanRule: `当预定后没去就餐的，扣${this.newRule.meijiucanRule}钱`
      };
      this.$axios.post('/api/add_rule', ruleData)
        .then(response => {
          const data = response.data;
          if (data.code === 0) {
            alert('规则添加成功');
            this.showDrawer = false;
            this.fetchRules(); // 刷新规则列表
          } else {
            alert('规则添加失败: ' + data.message);
          }
        })
        .catch(error => {
          console.error('Error adding rule:', error);
        });
    },
    deleteRule(id) {
      if (confirm('确定要删除这条规则吗？')) {
        this.$axios.post('/api/delete_rule', { id })
          .then(response => {
            const data = response.data;
            if (data.code === 0) {
              alert('规则删除成功');
              this.fetchRules(); // 刷新规则列表
            } else {
              alert('规则删除失败: ' + data.message);
            }
          })
          .catch(error => {
            console.error('Error deleting rule:', error);
          });
      }
    },
    search() {
      // 搜索逻辑已经在 computed 属性中实现
    },
    clear() {
      this.searchRuleName = '';
      this.searchType = '';
    }
  },
  mounted() {
    this.fetchRules();
  }
};
</script>

<style scoped>
.rules-container {
  padding: 20px;
  font-size: 12px;
}

.header {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.header input,
.header select,
.header button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-button {
  background-color: #007bff;
  color: white;
}

.clear-button {
  background-color: #dc3545;
  color: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.add-button {
  text-align: right;
  margin-top: 20px;
}

.add-button button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 20px;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.drawer-body {
  border-top: 1px solid #ccc;
  padding-top: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

button[type="submit"] {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.type-早餐 {
  color: green;
}

.type-午餐 {
  color: blue;
}

.type-晚餐 {
  color: orange;
}

.delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>